export default "__VITE_ASSET__DlAdHGGY__"